import { Injectable, computed, inject, signal } from '@angular/core';
import { GLOBAL_SETTINGS, IGlobalSettings } from '@partners/settings';
import { ScanCloudConfig } from '../../facades/scan/model/scan-cloud.model';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private _shellConfig = signal<IGlobalSettings>(inject(GLOBAL_SETTINGS));

  isDevMode$$ = computed<boolean>(() => {
    const { environment } = this._shellConfig();
    const { isDevMode } = environment;
    return isDevMode;
  });

  isMockMode$$ = computed<boolean>(() => {
    const { environment } = this._shellConfig();
    const { isMockMode } = environment;
    return isMockMode;
  });

  calEdaUri$$ = computed<string>(() => {
    const { environment } = this._shellConfig();
    const { calEdaUri } = environment;
    return calEdaUri;
  });
  scanConfig$$ = computed<ScanCloudConfig>(() => {
    const { environment } = this._shellConfig();
    const { scanConfig } = environment;
    /**
    when scan process is successfully completed we reload the whole app with an indication to avoid making any business-related "initialization" (reload/create profile)
    */
    return { ...scanConfig, completeCallbackUrl: `${window.location.origin}/scan/scan-document?ignoreNavigation=true` };
  });

  constructor() {}
}
